import { useResettableDebouncedValue } from '@/hooks/use-resettable-debounced-value';

interface UseDebouncedUserSearchResult {
  /** Immediate value — bind this to the input. */
  query: string;
  setQuery: (v: string) => void;
  /** Debounced value — pass this to the search query. */
  debouncedQuery: string;
  /** Instantly resets both `query` and `debouncedQuery` to empty (e.g. after selecting a
   *  result) — a plain `setQuery('')` would still take `delayMs` to reach `debouncedQuery`. */
  reset: () => void;
}

/** Shared debounce for the admin user-search inputs (`AdminRoleSwitch`'s `UserSearchInput`,
 *  `AssigneeSearchInput`) — both used to hand-roll an identical ref/setTimeout debounce
 *  block. Doesn't own dropdown-open state: `AssigneeSearchInput` derives it with extra
 *  blur/focus behavior the other doesn't have, so that stays local to each caller. */
export function useDebouncedUserSearch(delayMs = 300): UseDebouncedUserSearchResult {
  const { value, setValue, debounced, reset } = useResettableDebouncedValue(delayMs);
  return { query: value, setQuery: setValue, debouncedQuery: debounced, reset };
}
